import React, { useRef, useState, useEffect, useMemo } from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronDown, faChevronUp } from '@fortawesome/free-solid-svg-icons';
import generic from '../assets/img/generic.jpg';
import glutenFree from '../assets/img/Icons_16/GF.svg';
import vegetarian from '../assets/img/Icons_16/Veg.svg';
import vegan from '../assets/img/Icons_16/Vegan.svg';
import spicy from '../assets/img/Icons_16/Spicy.svg';
import extraSpicy from '../assets/img/Icons_16/extraSpicy.svg';
import ChevronDown from '../assets/img/chevronDown.svg';
import filigree from '../assets/img/roseFiligreeHeader.svg';
import { Steps } from '../lib/constants';
import disablePopUps from '../digital-menu-settings.json';

const MenuCard = props => {
    const { categoryIndex, item, culture, categoryType, activeStep
    } = props;
    const { uiTags = [], name, dietaryAndAllergens, minPrice, image, descriptionInfo } = item;

    const [isExpanded, setIsExpanded] = useState(false);
    const [showButton, setShowButton] = useState(false);

    // let params = new URL(document.location.toString()).searchParams;
    // let restaurantUrlId = params.get("restaurantId");

    const getCalories = (string) => {
        let safetyMeasure = 0
        while (string.length > 10 && safetyMeasure < 10) {
            let first = 0;
            safetyMeasure++
            let last = 0;
            first = string.indexOf("(", first);
            last = string.indexOf(")")

            if (first == -1 || last == -1) return null
            let phrase = string.slice(first + 1, last)
            if (/kcal/.test(phrase)) return phrase
            string = string.slice(last + 1);
        }
        return null
    }

    const cardInfo = useMemo(() => {
        let description = descriptionInfo.description;
        const calories = getCalories(description)
        if (!calories) return { calories: null, description }

        description = description.replace(/\([^()]*\)/g, '')
        description = description.replace(" .", ".");
        return { calories, description }
    }, [descriptionInfo])

    const textRef = useRef(null)

    const isOverflown = (ref) => {
        if (ref.current !== null) {
            return setShowButton(ref.current?.offsetHeight < ref.current?.scrollHeight || ref.current?.offsetWidth < ref.current?.scrollWidth);
        }
    };

    const expand = (e) => {
        e.stopPropagation();
        setIsExpanded(!isExpanded);
    };

    useEffect(() => {
        isOverflown(textRef);
    }, [item]);

    var popUpClickEventHandler = null;
    var onHoverDisabledCursor = "";
        
    if(!!disablePopUps)
    {
        if(item.name.toUpperCase() == 'PICCOLO MENU')
        {            
            popUpClickEventHandler = () => props.focusItem(item);
        }
        else{
            popUpClickEventHandler = expand;

            if(!showButton)
            { 
                onHoverDisabledCursor = 'on-hover-disable-cursor';                
            }
        }
    }
    else{
        popUpClickEventHandler = () => props.focusItem(item);
    }

    return (
        <>
        
            <li  className={`menu-card image`}>
                <a tabIndex={0} title={name} role="button" onClick={popUpClickEventHandler} className={`menu-card-inner ${onHoverDisabledCursor}`}>
                    <div className="menu-card-content">
                        <div className="menu-card-col description">
                            <div className="item-title-wrapper">
                                <div className="item-title">
                                    <h4>
                                        <span className="name">{name}</span>
                                    </h4>
                                </div>
                            </div>
                            {minPrice && (
                                <span className="icons-price-wrapper">
                                    <span className="dietary-icons-wrapper">
                                        {uiTags.includes('Glass - HiBal') && <span className={`glasses-icon highball`}></span>}
                                        {uiTags.includes('Glass - Martini') && <span className={`glasses-icon cocktail`}></span>}
                                        {uiTags.includes('Glass - Rocks') && <span className={`glasses-icon rocks`}></span>}
                                        {uiTags.includes('Glass - Wine') && <span className={`glasses-icon stemware`}></span>}
                                        {uiTags.includes('Glass - Prosecco') && <span className={`glasses-icon prosecco`}></span>}
                                        {uiTags.includes('Spicy 1') && (
                                            <span key={`dietary-${categoryIndex}-spicy-1`} className={`diet-icon spicy`}>
                                                <img src={spicy} alt="spicy" />
                                            </span>
                                        )}
                                        {uiTags.includes('Spicy 2') && (
                                            <span key={`dietary-${categoryIndex}-spicy-2`} className={`diet-icon spicy-hot`}>
                                                <img src={extraSpicy} alt="extraspicy" />
                                            </span>
                                        )}
                                        {dietaryAndAllergens && dietaryAndAllergens.includes('Gluten-Free') && (
                                            <span key="diet-icon-3" className={`diet-icon gluten-free`}>
                                                <img src={glutenFree} alt="Gluten-Free" />
                                            </span>
                                        )}
                                        {dietaryAndAllergens && dietaryAndAllergens.includes('Vegan') && (
                                            <span key="diet-icon-2" className={`diet-icon vegan`}>
                                                <img src={vegan} alt="Vegan" />
                                            </span>
                                        )}
                                        {dietaryAndAllergens && dietaryAndAllergens.includes('Vegetarian') && (
                                            <span key="diet-icon-1" className={`diet-icon vegetarian`}>
                                                <img src={vegetarian} alt="Vegetarian" />
                                            </span>
                                        )}
                                    </span>
                                </span>
                            )}

                        </div>

                        <div className="item-calories-container" >
                            {
                                (activeStep === Steps.PRE_ORDER)
                                &&
                                (
                                    <h5 style={{ marginBottom: 0 }} className='price-header'>
                                        <span className="price">
                                            {culture.symbol}
                                            {minPrice.toFixed(2)}
                                        </span>
                                    </h5>
                                )
                            }
                            {cardInfo?.calories && <div className="is-flex is-flex-column justify-center">
                                <span className="calorie" style={{fontSize: "0.75rem"}}>{cardInfo?.calories}</span>
                            </div>}
                        </div>
                            
                        {descriptionInfo.description && (
                            <div role="article" className='item-description-container'>
                                <div className="item-description"
                                    ref={textRef}
                                    style={{
                                        maxWidth: '100%',
                                        display: isExpanded ? 'flex' : '-webkit-box',
                                        flexDirection: "column",
                                        WebkitBoxOrient: 'vertical',
                                        WebkitLineClamp: 2,
                                        overflow: 'hidden',
                                        textOverflow: 'ellipsis',
                                        whiteSpace: 'normal',
                                    }}>
                                    <p>{cardInfo?.description}</p>
                                    {descriptionInfo.info && <p className="item-description-info">{descriptionInfo.info}</p>}
                                </div>
                                {showButton && (
                                    <div onClick={expand} style={{ paddingLeft: "5px" }}>
                                        {isExpanded ? (
                                            <img className="card-chevron" src={ChevronDown} alt="Logo" style={{ transform: 'rotate(180deg)' }} />
                                        ) : (
                                            <img className="card-chevron" src={ChevronDown} alt="Logo" />)}
                                    </div>
                                )}
                            </div>

                        )}


                        {uiTags.includes('New') || uiTags.includes('Popular') || uiTags.includes('It\'s Back!') ? (
                            <div className="tag-description">
                                {uiTags.includes('New') && <span className="uitag-text new">New</span>}
                                {uiTags.includes('Popular') && <span className="uitag-text popular">Popular</span>}
                                {uiTags.includes('It\'s Back!') && <span className="uitag-text new">It's Back!</span>}
                            </div>
                        ) : null}
                    </div>
                    <div
                        className={`menu-card-image ${image.trim() == '' &&
                            categoryType
                                .toLowerCase()
                                .trim()
                                .replace(/["~!@#$%^&*\(\)_+=`{}\[\]\|\\:;'<>,.\/?"\- \t\r\n]+/g, '-')
                            }`}>
                        <div className="menu-image-wrapper">
                            <figure
                                className="menu-image"
                                style={!image.trim() == '' ? { backgroundImage: `url(${item.image})` } : { backgroundImage: `url(${generic})` }}>
                                {uiTags.includes('New') || uiTags.includes('Popular') || uiTags.includes('It\'s Back!') ? (
                                    <div className="tag-description">
                                        {uiTags.includes('New') && <span className="uitag-text new">New</span>}
                                        {uiTags.includes('Popular') && <span className="uitag-text popular">Popular</span>}
                                        {uiTags.includes('It\'s Back!') && <span className="uitag-text new">It's Back!</span>}
                                    </div>
                                ) : null}
                            </figure>
                        </div>
                    </div>
                </a >
            </li >
            {
                descriptionInfo.title && (
                    <div className="menu-section-info">
                        <div className="menu-section-info-inner">
                            <div className="menu-section-info-content">
                                <h4 className="font-swash-on">{descriptionInfo.title.toUpperCase()}</h4>
                                <p className="sub-title">{descriptionInfo.subTitle}</p>
                            </div>
                        </div>
                    </div>
                )
            }
        </>
    )
}

export default MenuCard